import { useDetailUser, useIsSignedIn } from '@zelos/shared/lib/sign.service';
import { useEffect } from 'react';

const isProduction = process.env.IS_PRODUCTION;

export const useSetGaUserId = () => {
  const detailUser = useDetailUser();
  const isSignedIn = useIsSignedIn();

  useEffect(() => {
    if (!isProduction) return;
    window.dataLayer ??= [];
    if (isSignedIn === false) {
      const index = window.dataLayer.findIndex(({ user_id }) => Boolean(user_id));
      if (index !== -1) window.dataLayer.splice(index, 1);
    } else if (isSignedIn) {
      if (!detailUser?.programmersUserId || window.dataLayer.some(({ user_id }) => Boolean(user_id))) return;
      window.dataLayer.push({
        user_id: String(detailUser.programmersUserId),
      });
    }
  }, [detailUser?.programmersUserId, isSignedIn]);
};
